module.exports = __webpack_public_path__ + "static/9dca48d7.expect_more.png";